"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Progress = function (props) {
    const { cur, max, className, width } = props;
    const perc = `${parseFloat(`${((cur + 1) / max) * 100}`).toFixed(0)}%`;
    return (react_1.default.createElement("div", { className: `progress-bar ${className || ''}`, style: { width } },
        react_1.default.createElement("div", { className: "wrapper" },
            react_1.default.createElement("span", { className: "progress-bar-fill", style: { width: perc } }))));
};
Progress.defaultProps = {
    className: undefined,
    width: undefined,
};
exports.default = Progress;
